<template>
  <div class="page-content">
    <page-breadcrumb title="Grammar Cards" class="mb-2" />
    <data-create-popup title="Create Card" :schema="create_schema" :default-data="default_data"
      :create-data-fn="createItem" @create="$refs.card_list.getList()" />
    <data-table-ssr id="card_list" ref="card_list" :create_schema="create_schema" :get-list-fn="getList"
      :columns="card_fields" :to-edit-fn="toEditPage" />
  </div>
</template>

<script>
import { removeEmpty } from '@core/utils/index'
import service from '../service'
import default_data from '../default_data'
const create_schema = [
  {
    cols: 12,
    fields: [
      { label: 'Title', field: 'title', input_type: 'ui-component', validate: { required: true }, },
    ]
  }
];

const card_fields = [
  { label: 'Title', field: 'title', display_type: 'translatable-text' },
  { label: 'Subtile', field: 'subtitle', display_type: 'translatable-text' },
  { label: 'Description', field: 'description', display_type: 'translatable-text' },
];

export default {
  data() {
    return {
      create_schema,
      card_fields,
      total: 0,
      editing_data: null,
      default_data: { ...default_data },
    }
  },
  methods: {
    async createItem(data) {
      let new_item = await service.create(data);
      return new_item;
    },
    async getList({ limit, page, query }) {
      query = removeEmpty(query);
      let response = await service.getList({
        query: encodeURIComponent(JSON.stringify(query)),
        page,
        limit,
      });
      let list = []; let total = 0;
      if (response.data.type === "DATA") {
        list = response.data.data.list;
        total = response.data.data.total;
      }
      return { list, total }
    },
    async toEditPage({ _id }) {
      this.$router.push({ name: 'grammar-card-detail', params: { id: _id } });
    },
  }
}
</script>
